import { AUTH_BEGIN, LOGIN_SUCCESS, AUTH_ERROR, LOGOUT } from '../actions/auth'

const initialState = {
  currentUser: {},
  isLoggedIn: false,
  loading: false,
  email: null,
  error: ''
}

const authReducer = (state = initialState, action) => {
  switch (action.type) {
    // AUTH
    case AUTH_BEGIN:
      return {
        ...state,
        loading: true,
        error: ''
      }
    // AUTH_ERROR
    case AUTH_ERROR:
      return {
        ...state,
        loading: false,
        error: action.error
      }
    // LOGOUT
    case LOGOUT:
      return initialState
    // LOGIN
    case LOGIN_SUCCESS:
      return {
        currentUser: action.user,
        isLoggedIn: true,
        loading: true,
        error: ''
      }
    default:
      return state
  }
}

export default authReducer
